import angular from 'angular';
import toastr from 'angular-toastr';
import MailsResource from '../../cmsCore/MailsModules/MailsResource'
import angularDragula from 'angularjs-dragula';
import Context from '../../cmsCore/Creator/Context/Context';
import saveGuard from '../../cmsCore/SaveGuard/SaveGuard';
import cmsMailsPreview from './Preview/Preview'
import hlSticky from 'angular-sticky-plugin'
import deleteElementDialog from '../../cmsCore/DeleteElementModal/deleteElement';

let mailsFormPage = angular.module('cms.mails.add', [MailsResource, toastr, angularDragula(angular), cmsMailsPreview, saveGuard, 'hl.sticky', deleteElementDialog])

    .component('appMailsForm', {
        template: require('./templates/mailsForm.html'),
        controller: function (
            $scope,
            $rootScope,
            MailsResource,
            $stateParams,
            $state,
            toastr,
            gettextCatalog,
            dragulaService,
            deleteElementDialog,
            SaveWarning,
            SaveGuard,
            $element
        ) {
            /** @ngInject */

            this.$onInit = () => {
                this.context = new Context();
                this.context.setDragularScope($scope);
            };

            this.mail = {content: [], globalBackgroundColor: '#e0e0e0', globalHrefColor: "#2196f3"};
            if ($stateParams.id) {
                MailsResource.find({id: $stateParams.id},
                    response => {
                        this.mail = response;
                        this.blocked = response.form.length;
                        SaveWarning.watch(response, this.mail, $scope, $element);
                    }
                );
            } else {
                SaveWarning.watch(this.mail, this.mail, $scope, $element);
            }

            this.errors = {};
            this.pending = false;

            this.create = async (redirect = true) => {

                this.pending = true;
                await SaveGuard.check();

                return MailsResource.save(this.mail,
                    response => {
                        this.errors = {};
                        SaveWarning.watch(response, this.mail, $scope, $element);
                        toastr.success(
                            gettextCatalog.getString('Mail {{name}} added!', {name: this.mail.title}),
                            gettextCatalog.getString('Success')
                        );
                        if (redirect) {
                            goToReturnState();
                        }
                        this.pending = false;
                    },
                    response => {
                        this.errors = response.data;
                        this.pending = false;
                        this.onErrorMessage();
                    }
                ).$promise;
            };

            this.update = async (redirect = true) => {

                this.pending = true;
                await SaveGuard.check();

                return MailsResource.update(this.mail,
                    response => {
                        this.errors = {};
                        SaveWarning.watch(response, this.mail, $scope, $element);
                        toastr.success(
                            gettextCatalog.getString('Mail {{name}} saved!', {name: this.mail.title}),
                            gettextCatalog.getString('Success')
                        );
                        if (redirect) {
                            goToReturnState();
                        }
                        this.pending = false;
                    },
                    response => {
                        this.errors = response.data;
                        this.pending = false;
                        this.onErrorMessage();
                    }
                ).$promise
            };

            this.updateOrCreate = () => {
                if (this.mail.id) {
                    return this.update(false);
                } else {
                    return this.create(false);
                }
            };

            this.confirmDelete = () => {
                let deleteMessage = gettextCatalog.getString("Do you really want to delete this mail? (This action is irreversible!)");
                deleteElementDialog.open(deleteMessage).then(() => {
                    this.delete();
                }).catch(() => {
                });
            };

            this.delete = () => {
                this.pending = true;
                MailsResource
                    .delete({id: this.mail.id}, response => {
                        toastr.success(
                            gettextCatalog.getString('Mail {{name}} deleted!', {name: this.mail.title}),
                            gettextCatalog.getString('Success')
                        );
                        goToReturnState();
                        this.pending = false;
                    })
            };

            this.onErrorMessage = function () {
                return toastr.error(
                    gettextCatalog.getString('Please correct form errors and try again.', {name: this.mail.title}),
                    gettextCatalog.getString('Validation Errors')
                );
            };

            function goToReturnState() {
                SaveWarning.stopWatch();
                if ($stateParams.returnState) {
                    $state.go($stateParams.returnState.name, $stateParams.returnState.params)
                } else {
                    $state.go('mails', {})
                }
            }

            $scope.$on('save.object', () => {
                this.updateOrCreate();
            })

        }
    });

export default mailsFormPage.name;




// WEBPACK FOOTER //
// ./src/cmsPages/Mails/MailsFormPageDirective.js